import { useState } from "react"

import { useQuery } from "@tanstack/react-query"

import { getTripData } from "../api/getTripData.ts"

import TripOverviewTable from "./TripOverviewTable.tsx"

export default function TripOverview() {
  const [category, setCategory] = useState<"farms" | "drivers">("farms")
  const [showCount, setShowCount] = useState<boolean>(false)
  const { data, isPending } = useQuery({
    queryKey: ["tripData", { category, showCount }],
    queryFn: () => getTripData(category),
  })

  return (
    <div className="mt-4 md:mt-0 col-span-4">
      <div className="w-full rounded-md shadow-sm border overflow-x-scroll md:overflow-x-clip">
        <TripOverviewTable
          data={data || []}
          isLoading={isPending}
          category={category}
          setCategory={setCategory}
          setShowCount={setShowCount}
          showCount={showCount}
        />
      </div>
    </div>
  )
}
